﻿package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.RemoteInspection
import br.com.htms.inspeccaocampo.data.InspecaoCompleta
import br.com.htms.inspeccaocampo.export.ExportNames
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.platform.formatMonthYearPt
import br.com.htms.inspeccaocampo.platform.monthOf
import br.com.htms.inspeccaocampo.platform.yearOf
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import androidx.compose.material3.Button
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedHistoricoScreen(
    controller: AppController,
    snackbar: SnackbarHostState
) {
    val inspecoes by controller.inspecoes.collectAsState()
    val remotas by controller.remoteInspections.collectAsState()
    val historico by controller.historico.collectAsState()
    val authUser by controller.authUser.collectAsState()
    val isAdmin = authUser?.isAdmin == true

    LaunchedEffect(Unit) {
        controller.atualizarHistoricoRemoto()
    }

    val meses = remember(inspecoes) {
        inspecoes
            .map { yearOf(it.criadoEm) to monthOf(it.criadoEm) }
            .distinct()
            .sortedWith(compareByDescending<Pair<Int, Int>> { it.first }.thenByDescending { it.second })
    }
    var mesSelecionado by remember(meses) { mutableStateOf(meses.firstOrNull()) }
    var menuMesAberto by remember { mutableStateOf(false) }

    var filtroTexto by remember { mutableStateOf("") }
    var filtroUsuario by remember { mutableStateOf<String?>(null) }
    var filtroDe by remember { mutableStateOf("") }
    var filtroAte by remember { mutableStateOf("") }
    var menuUsuarioAberto by remember { mutableStateOf(false) }
    var confirmarExclusao by remember { mutableStateOf<RemoteInspection?>(null) }

    val usuariosRemotos = remember(remotas) {
        remotas.mapNotNull { it.username?.takeIf { u -> u.isNotBlank() } }
            .distinct()
            .sorted()
    }

    fun bateTexto(haystack: String, needle: String): Boolean {
        if (needle.isBlank()) return true
        return haystack.contains(needle, ignoreCase = true)
    }

    val deYmd = remember(filtroDe) { parseDateBrYmd(filtroDe) }
    val ateYmd = remember(filtroAte) { parseDateBrYmd(filtroAte) }

    val remotasFiltradas = remember(remotas, filtroTexto, filtroUsuario, deYmd, ateYmd) {
        val q = filtroTexto.trim()
        remotas.filter { r ->
            val userOk = filtroUsuario == null || r.username.equals(filtroUsuario, ignoreCase = true)
            if (!userOk) return@filter false
            val whenMs = r.dataHorarioMs ?: r.createdAt
            if (!dataNoPeriodo(whenMs, deYmd, ateYmd)) return@filter false
            if (q.isBlank()) return@filter true
            val blob = buildString {
                append(r.username.orEmpty()); append(' ')
                append(r.summaryTst); append(' ')
                append(r.summaryLocal); append(' ')
                append(r.summaryEfetivo.orEmpty()); append(' ')
                append(r.summaryObra.orEmpty()); append(' ')
                append(r.formTipoRotulo); append(' ')
                append(formatDateTimeBr(r.createdAt))
            }
            bateTexto(blob, q)
        }
    }

    val locaisFiltradas = remember(inspecoes, filtroTexto, deYmd, ateYmd) {
        val q = filtroTexto.trim()
        inspecoes.filter { insp ->
            if (!dataNoPeriodo(insp.criadoEm, deYmd, ateYmd)) return@filter false
            if (q.isBlank()) return@filter true
            val blob = buildString {
                append(insp.rotuloTipo); append(' ')
                append(insp.responsavelResumo()); append(' ')
                append(insp.obraResumo()); append(' ')
                append(insp.localResumo()); append(' ')
                append(insp.form.efetivo); append(' ')
                append(formatDateTimeBr(insp.criadoEm))
            }
            bateTexto(blob, q)
        }
    }

    val totalConsolidado = remember(remotasFiltradas, locaisFiltradas, isAdmin) {
        if (isAdmin) remotasFiltradas.size
        else {
            val remoteLocalIds = remotasFiltradas.mapNotNull { it.localId }.toSet()
            remotasFiltradas.size + locaisFiltradas.count { it.id !in remoteLocalIds }
        }
    }

    val locaisParaConsolidado = remember(locaisFiltradas, remotasFiltradas, isAdmin) {
        if (isAdmin) emptyList()
        else {
            val remoteLocalIds = remotasFiltradas.mapNotNull { it.localId }.toSet()
            locaisFiltradas.filter { it.id !in remoteLocalIds }
        }
    }

    LaunchedEffect(historico.mensagem) {
        historico.mensagem?.let {
            snackbar.showSnackbar(it)
            controller.limparMensagemHistorico()
        }
    }

    confirmarExclusao?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarExclusao = null },
            title = "Excluir inspeção",
            text = buildString {
                append("Remover permanentemente esta vistoria do servidor")
                if (!alvo.username.isNullOrBlank()) {
                    append(" (")
                    append(alvo.username)
                    append(")")
                }
                append("? PDF/Excel também serão apagados.")
            },
            confirmLabel = "Excluir",
            onConfirm = {
                controller.excluirRemoto(alvo.id)
                confirmarExclusao = null
            },
            dismissLabel = "Cancelar"
        )
    }

    val vazio = if (isAdmin) remotas.isEmpty() else (inspecoes.isEmpty() && remotas.isEmpty())
    if (vazio) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(MaterialTheme.colorScheme.background)
                .padding(24.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                if (isAdmin) "Nenhuma inspeção no servidor (últimos 30 dias)."
                else "Nenhuma inspeção salva ainda.",
                style = MaterialTheme.typography.titleMedium
            )
            Text(
                if (isAdmin) "Quando os usuários salvarem inspeções, elas aparecerão aqui para download."
                else "Preencha um formulário na aba Formulários e toque em Salvar.",
                style = MaterialTheme.typography.bodyMedium,
                modifier = Modifier.padding(top = 8.dp)
            )
            Text(
                "Histórico no servidor: 30 dias.",
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.padding(top = 12.dp)
            )
        }
        return
    }

    LazyColumn(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.background),
        contentPadding = PaddingValues(16.dp),
        verticalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        item {
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
            ) {
                Column(
                    modifier = Modifier.padding(12.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Text("Filtros", fontWeight = FontWeight.SemiBold)
                    OutlinedTextField(
                        value = filtroTexto,
                        onValueChange = { filtroTexto = it },
                        label = { Text("Buscar (obra, nome, data, local…)") },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    if (isAdmin && usuariosRemotos.isNotEmpty()) {
                        ExposedDropdownMenuBox(
                            expanded = menuUsuarioAberto,
                            onExpandedChange = { menuUsuarioAberto = it }
                        ) {
                            OutlinedTextField(
                                value = filtroUsuario ?: "Todos os usuários",
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Usuário") },
                                trailingIcon = {
                                    ExposedDropdownMenuDefaults.TrailingIcon(expanded = menuUsuarioAberto)
                                },
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .menuAnchor(),
                                colors = FormFieldDefaults.textFieldColors()
                            )
                            DropdownMenu(
                                expanded = menuUsuarioAberto,
                                onDismissRequest = { menuUsuarioAberto = false }
                            ) {
                                DropdownMenuItem(
                                    text = { Text("Todos os usuários") },
                                    onClick = {
                                        filtroUsuario = null
                                        menuUsuarioAberto = false
                                    }
                                )
                                usuariosRemotos.forEach { user ->
                                    DropdownMenuItem(
                                        text = { Text(user) },
                                        onClick = {
                                            filtroUsuario = user
                                            menuUsuarioAberto = false
                                        }
                                    )
                                }
                            }
                        }
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        OutlinedTextField(
                            value = filtroDe,
                            onValueChange = { filtroDe = it },
                            label = { Text("De (dd/MM/aaaa)") },
                            singleLine = true,
                            modifier = Modifier.weight(1f),
                            isError = filtroDe.isNotBlank() && deYmd == null,
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        OutlinedTextField(
                            value = filtroAte,
                            onValueChange = { filtroAte = it },
                            label = { Text("Até (dd/MM/aaaa)") },
                            singleLine = true,
                            modifier = Modifier.weight(1f),
                            isError = filtroAte.isNotBlank() && ateYmd == null,
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    }
                    if (isAdmin) {
                        Button(
                            onClick = {
                                val deMs = remotasFiltradas.map { it.dataHorarioMs ?: it.createdAt } +
                                    locaisParaConsolidado.map {
                                        it.dataHorarioMsResumo().takeIf { ms -> ms > 0 } ?: it.criadoEm
                                    }
                                controller.exportarConsolidado(
                                    remotas = remotasFiltradas,
                                    locais = locaisParaConsolidado,
                                    deLabel = filtroDe.trim().ifBlank {
                                        deMs.minOrNull()?.let { formatDateBr(it) }.orEmpty()
                                    },
                                    ateLabel = filtroAte.trim().ifBlank {
                                        deMs.maxOrNull()?.let { formatDateBr(it) }.orEmpty()
                                    }
                                )
                            },
                            enabled = totalConsolidado > 0 &&
                                !historico.exportandoConsolidado &&
                                !historico.exportandoLote &&
                                (filtroDe.isBlank() || deYmd != null) &&
                                (filtroAte.isBlank() || ateYmd != null),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            ButtonLoadingContent(
                                loading = historico.exportandoConsolidado,
                                idleText = "Baixar Excel completo (${totalConsolidado})",
                                loadingText = "Gerando Excel..."
                            )
                        }
                    }
                    if (filtroTexto.isNotBlank() || filtroUsuario != null ||
                        filtroDe.isNotBlank() || filtroAte.isNotBlank()
                    ) {
                        TextButton(onClick = {
                            filtroTexto = ""
                            filtroUsuario = null
                            filtroDe = ""
                            filtroAte = ""
                        }) { Text("Limpar filtros") }
                    }
                }
            }
        }

        if (remotas.isNotEmpty()) {
            item {
                Text(
                    if (isAdmin) "Servidor — todas as inspeções (30 dias)"
                    else "Servidor — minhas inspeções (30 dias)",
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleMedium
                )
            }
            if (remotasFiltradas.isEmpty()) {
                item {
                    Text(
                        "Nenhuma inspeção corresponde aos filtros.",
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            } else {
                items(remotasFiltradas, key = { "r-${it.id}" }) { remota ->
                    RemotoCard(
                        remota = remota,
                        showUser = isAdmin,
                        canDelete = isAdmin,
                        exportando = historico.exportandoRemoteId == remota.id || historico.exportandoLote,
                        onPdf = {
                            val name = ExportNames.remotePdf(
                                stored = remota.pdfFileName,
                                dataHorarioMs = remota.dataHorarioMs,
                                createdAt = remota.createdAt,
                                tstResponsavel = remota.summaryTst,
                                obra = remota.summaryObra,
                                localTexto = remota.summaryLocal
                            )
                            controller.baixarRemoto(remota.id, "pdf", name)
                        },
                        onExcel = {
                            val name = ExportNames.remoteExcel(
                                stored = remota.excelFileName,
                                dataHorarioMs = remota.dataHorarioMs,
                                createdAt = remota.createdAt,
                                tstResponsavel = remota.summaryTst,
                                obra = remota.summaryObra,
                                localTexto = remota.summaryLocal
                            )
                            controller.baixarRemoto(remota.id, "excel", name)
                        },
                        onExcluir = { confirmarExclusao = remota }
                    )
                }
            }
        }

        if (!isAdmin && inspecoes.isNotEmpty()) {
            item {
                Text(
                    "Neste aparelho",
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleMedium,
                    modifier = Modifier.padding(top = 8.dp)
                )
            }
            item {
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
                ) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Text("Exportar mês (ZIP com PDF + Excel)", fontWeight = FontWeight.SemiBold)
                        if (meses.isNotEmpty() && mesSelecionado != null) {
                            val (ano, mes) = mesSelecionado!!
                            val rotuloMes = formatMonthYearPt(ano, mes)
                            val qtd = inspecoes.count {
                                yearOf(it.criadoEm) == ano && monthOf(it.criadoEm) == mes
                            }
                            ExposedDropdownMenuBox(
                                expanded = menuMesAberto,
                                onExpandedChange = { menuMesAberto = it }
                            ) {
                                OutlinedTextField(
                                    value = "$rotuloMes ($qtd inspeções)",
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("Mês") },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = menuMesAberto) },
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .menuAnchor()
                                )
                                DropdownMenu(
                                    expanded = menuMesAberto,
                                    onDismissRequest = { menuMesAberto = false }
                                ) {
                                    meses.forEach { par ->
                                        DropdownMenuItem(
                                            text = { Text(formatMonthYearPt(par.first, par.second)) },
                                            onClick = {
                                                mesSelecionado = par
                                                menuMesAberto = false
                                            }
                                        )
                                    }
                                }
                            }
                            OutlinedButton(
                                onClick = { controller.exportarMes(ano, mes) },
                                enabled = !historico.exportandoLote && qtd > 0,
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                ButtonLoadingContent(
                                    loading = historico.exportandoLote,
                                    loadingText = "Gerando ZIP...",
                                    idleText = "Exportar $rotuloMes"
                                )
                            }
                        }
                    }
                }
            }

            if (locaisFiltradas.isEmpty()) {
                item {
                    Text(
                        "Nenhuma inspeção local corresponde à busca.",
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            } else {
                items(locaisFiltradas, key = { "l-${it.id}" }) { inspecao ->
                    HistoricoCard(
                        inspecao = inspecao,
                        exportando = historico.exportandoId == inspecao.id || historico.exportandoLote,
                        onEditar = { controller.carregarParaEdicao(inspecao) },
                        onPdf = { controller.exportarPdf(inspecao) },
                        onExcel = { controller.exportarExcel(inspecao) }
                    )
                }
            }
        }
    }
}

@Composable
private fun RemotoCard(
    remota: RemoteInspection,
    showUser: Boolean,
    canDelete: Boolean,
    exportando: Boolean,
    onPdf: () -> Unit,
    onExcel: () -> Unit,
    onExcluir: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(formatDateTimeBr(remota.createdAt), fontWeight = FontWeight.Bold)
            Text(
                "Tipo: ${remota.formTipoRotulo}",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            if (showUser && !remota.username.isNullOrBlank()) {
                Text("Usuário: ${remota.username}", style = MaterialTheme.typography.labelLarge)
            }
            if (!remota.summaryObra.isNullOrBlank()) {
                Text(
                    "Obra: ${remota.summaryObra}",
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    style = MaterialTheme.typography.titleSmall
                )
            }
            Text(
                remota.summaryTst,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text(
                "Local: ${remota.summaryLocal.replace("\n", " | ")}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (!remota.summaryEfetivo.isNullOrBlank()) {
                Text("Efetivo: ${remota.summaryEfetivo}")
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (remota.hasPdf) {
                    OutlinedButton(onClick = onPdf, enabled = !exportando, modifier = Modifier.weight(1f)) {
                        ButtonLoadingContent(
                            loading = exportando,
                            loadingText = "PDF...",
                            idleText = "Baixar PDF"
                        )
                    }
                }
                if (remota.hasExcel) {
                    OutlinedButton(onClick = onExcel, enabled = !exportando, modifier = Modifier.weight(1f)) {
                        Text("Baixar Excel")
                    }
                }
            }
            if (canDelete) {
                TextButton(
                    onClick = onExcluir,
                    enabled = !exportando,
                    modifier = Modifier.align(Alignment.End)
                ) {
                    Text("Excluir", color = MaterialTheme.colorScheme.error)
                }
            }
        }
    }
}

@Composable
private fun HistoricoCard(
    inspecao: InspecaoCompleta,
    exportando: Boolean,
    onEditar: () -> Unit,
    onPdf: () -> Unit,
    onExcel: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(formatDateTimeBr(inspecao.criadoEm), fontWeight = FontWeight.Bold)
            Text(
                "Tipo: ${inspecao.formTipo.rotuloCurto}",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            val obra = inspecao.obraResumo()
            if (obra.isNotBlank()) {
                Text(
                    "Obra: $obra",
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    style = MaterialTheme.typography.titleSmall
                )
            }
            Text(
                inspecao.responsavelResumo(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text(
                "Local: ${inspecao.localResumo().replace("\n", " | ")}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (inspecao.form.efetivo.isNotBlank()) {
                Text("Efetivo: ${inspecao.form.efetivo}")
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextButton(onClick = onEditar, enabled = !exportando) { Text("Editar") }
                OutlinedButton(onClick = onPdf, enabled = !exportando, modifier = Modifier.weight(1f)) {
                    ButtonLoadingContent(
                        loading = exportando,
                        loadingText = "PDF...",
                        idleText = "PDF"
                    )
                }
                OutlinedButton(onClick = onExcel, enabled = !exportando, modifier = Modifier.weight(1f)) {
                    Text("Excel")
                }
            }
        }
    }
}

/** dd/MM/yyyy → (ano, mês 1-12, dia) ou null se inválido/vazio. */
private fun parseDateBrYmd(raw: String): Triple<Int, Int, Int>? {
    val s = raw.trim()
    if (s.isEmpty()) return null
    val parts = s.split('/', '-', '.')
    if (parts.size != 3) return null
    val d = parts[0].toIntOrNull() ?: return null
    val m = parts[1].toIntOrNull() ?: return null
    val y = parts[2].toIntOrNull() ?: return null
    if (y !in 2000..2100 || m !in 1..12 || d !in 1..31) return null
    return Triple(y, m, d)
}

private fun ymdOfEpoch(epochMs: Long): Triple<Int, Int, Int>? =
    parseDateBrYmd(formatDateBr(epochMs).take(10))

private fun compareYmd(a: Triple<Int, Int, Int>, b: Triple<Int, Int, Int>): Int {
    val byY = a.first.compareTo(b.first)
    if (byY != 0) return byY
    val byM = a.second.compareTo(b.second)
    if (byM != 0) return byM
    return a.third.compareTo(b.third)
}

private fun dataNoPeriodo(
    epochMs: Long,
    de: Triple<Int, Int, Int>?,
    ate: Triple<Int, Int, Int>?
): Boolean {
    if (de == null && ate == null) return true
    val ymd = ymdOfEpoch(epochMs) ?: return true
    if (de != null && compareYmd(ymd, de) < 0) return false
    if (ate != null && compareYmd(ymd, ate) > 0) return false
    return true
}
